module.exports = __webpack_public_path__ + "1ea695f75337b693c0d30f7a2ef54f14.MP3";